import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Videos from "@/pages/Videos";
import Audio from "@/pages/Audio";
import Merch from "@/pages/Merch";
import Apply from "@/pages/Apply";
import Voicemail from "@/pages/Voicemail";
import Suggest from "@/pages/Suggest";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/videos" element={<Videos />} />
            <Route path="/audio" element={<Audio />} />
            <Route path="/merch" element={<Merch />} />
            <Route path="/apply" element={<Apply />} />
            <Route path="/voicemail" element={<Voicemail />} />
            <Route path="/suggest" element={<Suggest />} />
            <Route path="/admin" element={<Admin />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" richColors />
    </div>
  );
}

export default App;
